import { sendNotification } from '../components'

export const sendExportNotification = (message: string) =>
  sendNotification({
    type: 'success',
    toastContent: message,
    toastOptions: { autoClose: false },
    hyperLink: {
      type: 'newTab',
      label: 'reports',
      to: '/reports/',
      isExternalLink: false,
    },
  })

export const getExportHandler = async (_id: any, { queryFulfilled }: any) => {
  try {
    const { data } = await queryFulfilled

    sendNotification({
      type: 'success',
      toastContent: data.detail.message,
      toastOptions: { autoClose: false },
      hyperLink: {
        type: 'newTab',
        label: 'reports',
        to: '/reports/',
        isExternalLink: false,
      },
    })
  } catch (err) {}
}

export const sendImportNotification = (message: string) =>
  sendNotification({
    type: 'success',
    toastContent: message,
    toastOptions: { autoClose: false },
    hyperLink: {
      type: 'newTab',
      label: 'imports',
      to: '/reports/1',
      isExternalLink: false,
    },
  })

export const getImportHandler = async (_id: any, { queryFulfilled }: any) => {
  try {
    const { data } = await queryFulfilled

    sendNotification({
      type: 'success',
      toastContent: data.detail.message,
      toastOptions: { autoClose: false },
      hyperLink: {
        type: 'newTab',
        label: 'imports',
        to: '/reports/1',
        isExternalLink: false,
      },
    })
  } catch (err) {}
}

// Dummy client utilities
export {
  getDummyClientIds,
  isDummyClient,
  isDummyModeDisabled,
  setDummyModeDisabled,
} from './dummyClientUtils'
